








































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CampagnaGeneralData from './CampagnaGeneralData.vue';
import CampagnaTabella from './CampagnaTabella.vue';
import CampagnaContattiList from './CampagnaContattiList.vue';
import CampagnaOperatoriList from './CampagnaOperatoriList.vue';
import { CrudService } from '@/data/services/crud.service';
import { Campaign } from '@/data/models/campaign.model';

@Component({
	components: {
		CampagnaGeneralData,
		CampagnaTabella,
		CampagnaContattiList,
		CampagnaOperatoriList,
		ValidationObserver,
		ValidationProvider,
	},
})
export default class CampagnaDetail extends Vue {
	@Prop() campagnaid?: number | string;
	@Prop({ default: true }) editable!: boolean;

	@Inject('CrudService') campagnaCrudService!: CrudService<Campaign>;

	campagna!: Campaign;

	loading: boolean = false;

	constructor() {
		super();
		this.campagna = new Campaign();
		this.campagna.maxrecall = 3;
	}

	loadCampagna(id: number) {
		this.loading = true;
		
		this.campagnaCrudService
			.getEntity(Campaign, 'campaign', id)
			.then(result => {
				this.campagna = result;
			})
			.catch(error => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger'
				});
			}).finally(() => this.loading = false);
	}

	created() {
		if (this.campagnaid) {
			this.loadCampagna(+this.campagnaid);
		}
	}
}
